import React, { useState } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Button,
  IconButton,
  TableHead,
} from '@mui/material';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import {
  IAMCRequest,
  IFreeConsultancyRequest,
  ITechnician,
} from '../../../utils/entities/interface';
import {
  capitalizeWords,
  formatBookingSlot,
  lockWidth,
} from '../../../utils/helper';
import { useNavigate } from 'react-router-dom';
import { RemoveRedEyeOutlined, Visibility } from '@mui/icons-material';

import { ToggleTechnicianStatus } from '../../../services/technician';
import { SkeletonRows } from '../../skeletons/list';
import { SquareProfileImage } from '../../atoms/Avatar';
import { DialogBoxComp } from '../../atoms/DialogBox';
import { ListTable } from '../../molecules/ListTable';

export const ConsultancyRequests = ({
  requests,
  isLoading,
  onUpdate,
  tableCell,
  onManageClick,
}: {
  requests: any[];
  isLoading: boolean;
  onUpdate: () => void;
  tableCell?: any[];
  onManageClick: (id: string) => void;
}) => {
  const [open, setOpen] = useState<boolean>(false);
  const navigate = useNavigate();
  const [selectedTechnician, setSelectedTechnician] =
    useState<ITechnician | null>(null);

  const actions = [
    {
      icon: <RemoveRedEyeOutlined />,
      onClick: (row: any) => onManageClick(row._id),
    },
  ];

  const handleOpen = (technician: ITechnician) => {
    setSelectedTechnician(technician);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedTechnician(null);
  };

  const handleConfirm = async () => {
    if (selectedTechnician) {
      try {
        await ToggleTechnicianStatus(selectedTechnician._id);
        onUpdate();
        handleClose();
      } catch (error) {
        alert(
          error instanceof Error ? error.message : 'Failed to update status',
        );
      }
    }
  };

  return (
    <>
      <ListTable
        headerCells={tableCell?.map((cell) => cell) || []}
        rows={requests}
        isLoading={isLoading}
        actions={actions}
        renderCell={(request: any, colIndex: number) => {
          switch (colIndex) {
            case 0:
              return request?.consultancyId || '-';

            case 1:
              return capitalizeWords(request?.userDetails?.name) || 'N/A';

            case 2:
              return 'Free Consultancy';

            case 3:
              return capitalizeWords(request?.technicianName) || 'N/A';

            case 4:
              return `+91-${request?.userDetails?.phoneNumber?.slice(0, 10)}`;

            case 5:
              return formatBookingSlot(request?.date, request?.slot);

            case 6:
              return (
                capitalizeWords(request?.enquiryStatus || request?.status) ||
                'N/A'
              );

            default:
              return null;
          }
        }}
      />

      <DialogBoxComp
        open={open}
        title={
          selectedTechnician?.active
            ? 'Disable Technician'
            : 'Enable Technician'
        }
        content={`Are you sure you want to ${
          selectedTechnician?.active ? 'disable' : 'enable'
        } this technician?`}
        handleClose={handleClose}
        handleConfirm={handleConfirm}
      />
    </>
  );
};
